import styled from 'styled-components';
import {Button} from '@mui/material';

function GenderField(props) {
    const {value, onClickHandler} = props;

    return (
        <StyledGender>
            <p style={{color: '#707070', paddingBottom: '16px'}}>Sex* :</p>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <StyledButton
                    uppercase={false}
                    name="sex"
                    isActive={value === 'Male'}
                    onClick={() => onClickHandler('Male')}
                >
                    Male
                </StyledButton>
                <StyledButton
                    name="sex"
                    isActive={value === 'Female'}
                    onClick={() => onClickHandler('Female')}
                >
                    Female
                </StyledButton>
            </div>
        </StyledGender>
    );
}

const StyledGender = styled.div`
  @media screen and (min-width: 1024px) {
    min-height: 114px;
    display: grid;
    grid-template-columns: 50% 50%;
    place-content: center;

    p {
      color: #4e4e4e !important;
      margin: auto 0 !important;
      padding: 0 !important;
      font-size: 24px !important;
      font-weight: 400 !important;
    }
  }

`

const StyledButton = styled(Button)`
  width: 45%;
  height: 48px;
  border-radius: 16px !important;
  border: 1px !important;
  font-size: 14px;
  text-transform: unset !important;
  background: ${({isActive}) =>
          isActive ? '#e0dbe7 !important' : '#f5f5f5 !important'};
  color: ${({isActive}) => (isActive ? '#6f4d9f !important' : '#707070 !important')};
  box-shadow: ${({isActive}) =>
          isActive
                  ? '2px 2px 10px 0px #6f4d9f80 inset'
                  : '1px 1px 2px 0px #00000029'};
  @media screen and (min-width: 1024px) {
    height: 64px !important;
    width: 150px !important;
    font-size: 20px !important;
    font-family: ${({isActive}) => (isActive ? 'dana-bold' : '400')};
    background: ${({isActive}) =>
            isActive ? '#e0dbe7 !important' : '#ffffff !important'};
    :hover {
      background: #e0dbe7 !important;
      box-shadow: 2px 2px 10px 0px #6f4d9f80 inset
    }
  }
`;

export {GenderField};
